import type { ColumnDef } from '@tanstack/react-table';
import { cn } from '@/lib/utils';
import { CellAction } from './cell-action';
import type { ProjectListItem } from '@/services/types';
import { Badge } from '@/components/ui/badge';

export const createColumns = (activeOrganisationId?: string): ColumnDef<ProjectListItem>[] => [
  /* {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllRowsSelected()}
        onCheckedChange={(value) => table.toggleAllRowsSelected(!!value)}
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
      />
    ),
    enableSorting: false,
    enableHiding: false
  }, */
  {
    accessorKey: 'company',
    header: 'Company',
    cell: ({ row }) => {
      const { organisation } = row.original;
      const isOwnProject = organisation && typeof organisation === 'object' ? organisation?.id === activeOrganisationId : false      
      return (
        <div className='flex items-center space-x-2'>
          <p>{organisation?.name}</p>
          {isOwnProject && (
            <Badge variant='outline' className='bg-blue-50 text-blue-700 border-blue-200 text-xs px-2 py-0.5'>
              Me
            </Badge>
          )}
        </div>
      );
    }
  },
  {
    accessorKey: 'title',
    header: 'Projects'
  },
  {
    accessorKey: 'timeline',
    header: 'Timeline',
    cell: ({ row }) => {
      const timeline = row.getValue<string>('timeline');
      return <p>{timeline}</p>;
    }
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => {
      const status = row.getValue<string>('status');
      return (
        <div
          className={cn(
            'w-[100px] rounded-[16px] border px-4 py-2 text-center text-xs capitalize',
            status?.toLocaleLowerCase() === 'pending'
              ? 'bg-[#FFD8C7] text-[#C23F0F]'
              : 'bg-[#D6EFE0] text-[#357372]'
          )}
        >
          {status}
        </div>
      );
    }
  },
  {
    id: 'actions',
    cell: ({ row }) => <CellAction data={row.original} activeOrganisationId={activeOrganisationId} />
  }
];

// Export default columns for backward compatibility
// export const columns = createColumns();
